import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "types";
import { initialState } from "./slice";

const selectDomain = (state: RootState) =>
  state.accountSettings || initialState;

export const selectAccountSettings = createSelector(
  [selectDomain],
  (accountSettingsState) => accountSettingsState
);
